// extracted by mini-css-extract-plugin
export default {"Navigation":"mosJUWVNWiem7N4QdMpa","Link":"vk_K4c0hMX4JmsSKJTyh","ActiveLink":"H4sz0SzLcqAcz_l3Cmjh"};